<template>
  <form @submit.prevent="handleSubmit" id="category_create_form">
    <!-- Email Address -->
    

    <!-- First Name -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Category Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name"
        v-model="form.name" placeholder="Category Name"  />

    </div>

    <!-- Last Name -->
    

    

     <div class="mb-3">
      <label class="form-label form-label-thin">Description If Any </label>
      <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
        v-model="form.description" placeholder="Category Description" rows="2"></textarea>

    </div>


    

   

    

    <!-- Modal Footer -->
     <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close">
          <i class="fa fa-times"></i> Cancel
        </button>
      <button type="submit" class="btn btn-primary text-light hover-white btn-md form-submit-btn">
        <i class="fa fa-save"></i> Create Category
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'CreateWOCategory',
  emits: ['created', 'close'],
  data() {
    return {
      form: {
        name: '',
        description: '',
        head: '',
        members: []
      },
      submitting: false,
      members: []
    }
  },
  mounted() {
    this.get_members()
  },
  methods: {
    async handleSubmit() {
      this.submitting = true

      const result = await form_api_submit({
        url: 'wo/category/create',
        method: 'POST',
        data: this.form,
        curr_form_id: '#category_create_form',
      })

      if (result.success) {
        this.$emit('created')
        this.close()
        this.resetForm()
      }

      this.submitting = false
    },


    async get_members() {
      this.submitting = true

      const result = await form_api_submit({
        url: 'user/dropdown',
        method: 'GET',
        data: this.form,
        show_success_toast:false
      })

      if (result.success) {
        this.members = result.data
      }

    },

    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        name: '',
        description: '',
        head: '',
        members: []
      }
    }
  }
}
</script>